module.exports = __webpack_public_path__ + "img/yslogo.3cc2a7db.png";